export const getters = {
  contact_infos: state => state
}
let session
try {
  session = JSON.parse(localStorage.getItem('session'))
} catch (e) {
  session = {}
}

export default {
  user_mail: session ? session.user_mail || undefined : undefined,
  user_firstname: session ? session.user_firstname || undefined : undefined,
  user_lastname: session ? session.user_lastname || undefined : undefined,
  user_phone: session ? session.user_phone || '' : ''
}
